import { supabase } from '../supabase';
import { OFFLINE_COMMAND_TYPES, shouldRunLocalHostPath } from './offlineQueueConstants';

export async function saveMatchPreferenceMaybeOffline({
  sessionId,
  playerId,
  matchPreference,
  preferenceStrength,
  offlineQueue = null,
  session = null,
  snapshot = null,
}) {
  if (!sessionId || !playerId) {
    throw new Error('Missing session or player');
  }

  const updatedAt = new Date().toISOString();
  if (shouldRunLocalHostPath(offlineQueue, session) && typeof offlineQueue?.enqueue === 'function') {
    const nextMetrics = {
      ...(snapshot?.playerWaitMetrics || {}),
      [playerId]: {
        ...(snapshot?.playerWaitMetrics?.[playerId] || {}),
        matchPreference,
        preferenceStrength,
        sessionPlayerRowUpdatedAt: updatedAt,
      },
    };
    await offlineQueue.enqueue(
      {
        type: OFFLINE_COMMAND_TYPES.PREFERENCE,
        playerId,
        matchPreference,
        preferenceStrength,
      },
      { ...(snapshot || {}), playerWaitMetrics: nextMetrics }
    );
    return { updated_at: updatedAt, local: true };
  }

  const { data: row, error } = await supabase
    .from('session_players')
    .update({
      match_preference: matchPreference,
      preference_strength: preferenceStrength,
      updated_at: updatedAt,
    })
    .eq('session_id', sessionId)
    .eq('player_id', playerId)
    .select('updated_at')
    .maybeSingle();

  if (error) throw error;
  if (!row) throw new Error('Preference update did not apply');
  return { updated_at: row.updated_at || updatedAt };
}

export async function flushPreferenceFromOfflineCommand(command, { sessionId }) {
  if (!sessionId || !command?.playerId) {
    throw new Error('Missing preference player');
  }
  const { data, error } = await supabase
    .from('session_players')
    .update({
      match_preference: command.matchPreference || 'no_preference',
      preference_strength: command.preferenceStrength || 'soft',
      updated_at: new Date().toISOString(),
    })
    .eq('session_id', sessionId)
    .eq('player_id', command.playerId)
    .select('id')
    .maybeSingle();
  if (error) throw error;
  if (!data) {
    throw new Error('Preference flush did not apply');
  }
}
